import type { ComponentPropsWithoutRef, ReactNode } from 'react'

import styles from '@runtime/components/ui/Tabs.module.scss'

type TabsVariant = 'strategy' | 'strategyBoard' | 'aiLevel' | 'handCounts'
type TabsContext = 'menu' | 'net'

type TabsProps = {
  variant?: TabsVariant | TabsVariant[]
  context?: TabsContext
  className?: string
  children: ReactNode
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>

export function Tabs({
  variant,
  context,
  className,
  children,
  ...props
}: TabsProps) {
  const variants = Array.isArray(variant) ? variant : variant ? [variant] : []
  const variantClasses = variants
    .map((v) =>
      v === 'strategy'
        ? styles.strategyTabs
        : v === 'strategyBoard'
          ? styles.strategyBoardTabs
          : v === 'aiLevel'
            ? styles.aiLevelTabs
            : v === 'handCounts'
              ? styles.handCountsTabs
              : '',
    )
    .filter(Boolean)

  const classes = [styles.tabs, ...variantClasses, className || '']
    .filter(Boolean)
    .join(' ')
  const tabs = (
    <div className={classes} {...props}>
      {children}
    </div>
  )

  if (!context) return tabs

  const contextClass =
    context === 'menu' ? styles.menuBlockContext : styles.netBoxContext
  return <div className={contextClass}>{tabs}</div>
}

type TabButtonProps = {
  active?: boolean
  className?: string
} & ComponentPropsWithoutRef<'button'>

export function TabButton({
  active,
  className,
  type,
  ...props
}: TabButtonProps) {
  const classes = [styles.tab, active ? styles.active : '', className || '']
    .filter(Boolean)
    .join(' ')
  return <button className={classes} type={type || 'button'} {...props} />
}
